"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2753,2826,8906],{

/***/ 82964:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ TabListNameEnums; },
/* harmony export */   "F": function() { return /* binding */ CompanyActionEnums; }
/* harmony export */ });
var CompanyActionEnums;
(function(CompanyActionEnums) {
    CompanyActionEnums["STREAM"] = "stream";
    CompanyActionEnums["NEWS"] = "news";
    CompanyActionEnums["KEYSTATS"] = "keystats";
    CompanyActionEnums["FINANCIALS"] = "financials";
    CompanyActionEnums["FUNDACHART"] = "fundachart";
    CompanyActionEnums["CHARTBIT"] = "chartbit";
    CompanyActionEnums["COMPARISON"] = "comparison";
    CompanyActionEnums["INSIDER"] = "insider";
    CompanyActionEnums["PROFILE"] = "profile";
    CompanyActionEnums["CORPACTION"] = "corp_action";
    CompanyActionEnums["SEASONALITY"] = "seasonality";
    CompanyActionEnums["ANALYST"] = "analysis";
})(CompanyActionEnums || (CompanyActionEnums = {}));
var TabListNameEnums;
(function(TabListNameEnums) {
    TabListNameEnums["HOME"] = "";
    TabListNameEnums["STREAM"] = "stream";
    TabListNameEnums["NEWS"] = "news";
    TabListNameEnums["KEYSTATS"] = "keystats";
    TabListNameEnums["ANALYST"] = "analyst";
    TabListNameEnums["FINANCIALS"] = "financials";
    TabListNameEnums["FUNDACHART"] = "fundachart";
    TabListNameEnums["SEASONALITY"] = "seasonality";
    TabListNameEnums["CHARTBIT"] = "chartbit";
    TabListNameEnums["COMPARISON"] = "comparison";
    TabListNameEnums["INSIDER"] = "insider";
    TabListNameEnums["PROFILE"] = "profile";
    TabListNameEnums["CORP_ACTION"] = "corp.action";
    TabListNameEnums["CONSENSUS"] = "EPS Estimate";
    TabListNameEnums["CORP_ACTION_NEW_NAME"] = "corpaction";
    TabListNameEnums["BUY"] = "buy";
})(TabListNameEnums || (TabListNameEnums = {}));


/***/ }),

/***/ 19970:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Chart_EmptyChart; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/features/company/Chart/EmptyChartIcon.tsx

var EmptyChartIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "160",
        height: "120",
        viewBox: "0 0 160 120",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M105.128 39.5544C105.093 39.7033 105.058 39.8609 105.023 40.0097C99.017 38.1537 92.232 36.5165 84.9919 35.2471C77.384 33.9164 70.1175 33.1197 63.5952 32.8483C63.6302 32.2355 63.709 31.6139 63.8404 31.001C65.7139 21.9486 76.4822 16.5207 87.8809 18.8845C99.2796 21.2482 107.01 30.502 105.128 39.5544V39.5544Z",
                stroke: "#00AB6B",
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M67.9727 29.5915C68.4279 28.6022 69.0407 27.6742 69.7936 26.8425C71.6672 24.7589 74.3899 23.2006 77.6029 22.4214",
                stroke: "#00AB6B",
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M82.5493 21.8348C84.0814 21.8348 85.6398 21.9924 87.1718 22.3163L82.5493 21.8348Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M82.5493 21.8348C84.0814 21.8348 85.6398 21.9924 87.1718 22.3163",
                stroke: "#00AB6B",
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M59.4093 55.3945C44.437 50.6573 34.6907 44.611 35.5529 39.7532C36.781 32.837 59.026 30.9163 85.2253 35.4726C111.433 40.0288 131.675 49.3309 130.447 56.2471C129.515 61.5011 116.441 63.8783 98.7169 62.7069",
                stroke: "#00AB6B",
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M96.0023 108.149C79.7362 110.701 54.0608 107.431 40.3736 99.4459C39.5111 98.9407 39.241 97.8152 39.7724 96.9644L66.6589 46.8471C66.6589 46.8471 68.5321 43.5857 81.1738 45.7304C93.8068 47.8751 94.5648 51.5353 94.5648 51.5353L97.3092 104.356L97.4921 106.217C97.5793 107.156 96.9345 107.998 96.011 108.149H96.0023Z",
                fill: "#E6FCEF"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M95.5 61L96.5 83",
                stroke: "#00AB6B",
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M94.5879 51.7369C94.8999 49.8478 88.8764 47.2795 81.1339 46.0005C73.3915 44.7215 66.862 45.2162 66.5499 47.1053C66.2378 48.9944 72.2614 51.5626 80.0039 52.8416C87.7463 54.1206 94.2758 53.626 94.5879 51.7369Z",
                stroke: "#00AB6B",
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M62.6487 49.9674C59.8235 48.3322 58.2675 46.5953 58.5283 45.0279C59.1629 41.2829 69.9681 39.9019 82.6509 41.9438C95.3425 43.9857 105.113 48.6796 104.47 52.433C104.174 54.1614 101.732 55.3815 97.9416 56",
                stroke: "#00AB6B",
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M68.2883 91.2029L69.4956 78.1658C69.5486 77.5833 69.1144 77.0643 68.5319 77.0114L64.7828 76.6936C64.2003 76.6407 63.6919 77.0749 63.639 77.6468L62.4316 90.684C62.3787 91.2665 62.8129 91.7854 63.3954 91.8384L67.1445 92.1561C67.727 92.209 68.2353 91.7748 68.2883 91.2029Z",
                stroke: "#00AB6B",
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M65.0587 91.9761L64.688 96.4242",
                stroke: "#00AB6B",
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M66.9324 73.6118L66.6782 76.556",
                stroke: "#00AB6B",
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M85.1669 71.2379L83.9237 64.024C83.8449 63.5424 83.3809 63.2185 82.8994 63.3148L79.8353 63.8839C79.3625 63.9714 79.0561 64.4179 79.1349 64.8907L80.3781 72.1046C80.4569 72.5861 80.9209 72.91 81.4024 72.8137L84.4665 72.2447C84.9393 72.1571 85.2457 71.7106 85.1669 71.2379V71.2379Z",
                stroke: "#00AB6B",
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M82.7598 72.5599L83.4426 76.1931",
                stroke: "#00AB6B",
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M80.8945 60.951L81.341 63.3499",
                stroke: "#00AB6B",
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M69.5 66C70.6046 66 71.5 65.1046 71.5 64C71.5 62.8954 70.6046 62 69.5 62C68.3954 62 67.5 62.8954 67.5 64C67.5 65.1046 68.3954 66 69.5 66Z",
                stroke: "#00AB6B",
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M84.5 97C86.1569 97 87.5 95.6569 87.5 94C87.5 92.3431 86.1569 91 84.5 91C82.8431 91 81.5 92.3431 81.5 94C81.5 95.6569 82.8431 97 84.5 97Z",
                stroke: "#00AB6B",
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M47.5 69L52.5 62",
                stroke: "#00AB6B",
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M101.5 75L100.5 68",
                stroke: "#00AB6B",
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M41.5 93L53.5 71",
                stroke: "#00AB6B",
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M122.5 20L115.251 24.3274L118.326 26.8071L112.5 30",
                stroke: "#00AB6B",
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M122.5 32L116.5 34",
                stroke: "#00AB6B",
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/* harmony default export */ var Chart_EmptyChartIcon = (EmptyChartIcon);

// EXTERNAL MODULE: ./src/features/company/Chart/styled.ts
var styled = __webpack_require__(33263);
;// CONCATENATED MODULE: ./src/features/company/Chart/EmptyChart.tsx



var EmptyChart = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* EmptyStateWrapper */.$c, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "no-data",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Chart_EmptyChartIcon, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "margin-top-18 text-empty-state",
                    children: "Data Chart Belum Tersedia"
                })
            ]
        })
    });
};
/* harmony default export */ var Chart_EmptyChart = (EmptyChart);


/***/ }),

/***/ 68068:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76825);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33263);
/* eslint-disable no-undef */ 


var IconWrapper = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.IconWrapper */ .Gn.IconWrapper, Button = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Button */ .Gn.Button;
function ExpandButtonToggle(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, onExpand = param.onExpand;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__/* .ExpandButtonToggleWrapper */ .f, {
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Button, {
            width: "25px",
            height: "16px",
            onClick: onExpand,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconWrapper, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__/* .NotHoverIcon */ .Et, {
                    className: "icon-toolbar_down",
                    color: _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.midgray */ .$_.midgray,
                    size: "14px"
                })
            })
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (ExpandButtonToggle);


/***/ }),

/***/ 5856:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76825);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91296);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_debounce__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);




var Flex = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Flex */ .Gn.Flex, Text = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Text */ .Gn.Text;
var RadioButton = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Company.RadioButton */ .YD.RadioButton;
function TimeframeButtons(param) {
    var showTimeframes = param.showTimeframes, timeframe = param.timeframe, onSelectTimeframe = param.onSelectTimeframe, className = param.className, _timeFrameList = param.timeFrameList, timeFrameList = _timeFrameList === void 0 ? [] : _timeFrameList;
    var debouncedOnChange = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(lodash_debounce__WEBPACK_IMPORTED_MODULE_2___default()(function(e) {
        onSelectTimeframe(e.target.value);
    }, 0), [
        onSelectTimeframe
    ]);
    return showTimeframes ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Flex, {
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RadioButton.Group, {
            value: timeframe,
            onChange: debouncedOnChange,
            type: "solid-primary",
            children: timeFrameList.map(function(opt) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RadioButton.Button, {
                    value: opt.value,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Text, {
                        className: "text",
                        height: "1.15",
                        padding: "2px 0",
                        align: "center",
                        width: "30px",
                        children: opt.label
                    })
                }, opt.value);
            })
        })
    }) : null;
}
/* harmony default export */ __webpack_exports__["Z"] = (TimeframeButtons);


/***/ }),

/***/ 82495:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Chart; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@stockbit/ui/index.js
var ui = __webpack_require__(76825);
// EXTERNAL MODULE: ./node_modules/numeral/numeral.js
var numeral = __webpack_require__(92077);
var numeral_default = /*#__PURE__*/__webpack_require__.n(numeral);
// EXTERNAL MODULE: ./src/features/company/constants.ts
var constants = __webpack_require__(55564);
// EXTERNAL MODULE: ./src/utils/general.js
var general = __webpack_require__(42227);
// EXTERNAL MODULE: ./src/features/company/Chart/styled.ts
var styled = __webpack_require__(33263);
// EXTERNAL MODULE: ./src/features/company/Chart/ExpandButtonToggle.tsx
var ExpandButtonToggle = __webpack_require__(68068);
;// CONCATENATED MODULE: ./src/features/company/Chart/ChartDetail.tsx








var Flex = ui/* Common.Flex */.Gn.Flex, Text = ui/* Common.Text */.Gn.Text;
function ChartDetail(param) {
    var stateTimeframe = param.timeframe, showTimeframes = param.showTimeframes, _company = param.company, company = _company === void 0 ? {} : _company, chart = param.chart, onSelectTimeframe = param.onSelectTimeframe, onExpand = param.onExpand;
    var _time = company.time, time = _time === void 0 ? "" : _time, companyChange = company.change, companyPercentage = company.percentage, price = company.price, volume = company.volume, average = company.average;
    var ref;
    var timeframe = (ref = chart === null || chart === void 0 ? void 0 : chart.timeframe) !== null && ref !== void 0 ? ref : stateTimeframe;
    var isTimeframeToday = timeframe === "today";
    var change = isTimeframeToday ? companyChange : chart === null || chart === void 0 ? void 0 : chart.change;
    var percentage = isTimeframeToday ? companyPercentage : chart === null || chart === void 0 ? void 0 : chart.percentage;
    var renderTime = (0,react.useCallback)(function() {
        if (timeframe === "today") {
            var timeOnly = time.slice(4);
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    "Today ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("time", {
                        dateTime: "".concat(timeOnly, "+07:00"),
                        children: "".concat(time, " WIB")
                    })
                ]
            });
        }
        if (timeframe === "ytd") {
            return "Year to Date";
        }
        if (timeframe[1] === "w") {
            return "Past ".concat(timeframe[0], " Week");
        }
        if (timeframe[1] === "m") {
            return "Past ".concat(timeframe[0], " Month");
        }
        if (timeframe[1] === "y") {
            return "Past ".concat(timeframe[0], " Year");
        }
        return "";
    }, [
        timeframe,
        time
    ]);
    var numeralChange = (0,react.useMemo)(function() {
        return numeral_default()(change);
    }, [
        change
    ]);
    var priceType = (0,react.useMemo)(function() {
        if (numeralChange.value() > 0) return "up";
        if (numeralChange.value() < 0) return "down";
        return "netral";
    }, [
        numeralChange
    ]);
    var formattedPrice = (0,react.useMemo)(function() {
        return numeral_default()(price).format("0,0.[00]");
    }, [
        price
    ]);
    var formattedChange = (0,react.useMemo)(function() {
        var val = numeralChange.value();
        if (isNaN(val)) return "NA";
        if (val === 0) return "0.00";
        return numeralChange.format("+0,0.[00]");
    }, [
        numeralChange
    ]);
    var formattedPercentage = (0,react.useMemo)(function() {
        return numeral_default()(percentage || 0).format("0.00");
    }, [
        percentage
    ]);
    var formattedVolume = (0,react.useMemo)(function() {
        return isNaN(volume) ? "NA" : (0,general/* parseCountAbbrv2 */.St)(volume);
    }, [
        volume
    ]);
    var formattedAvgVolume = (0,react.useMemo)(function() {
        return isNaN(Number(average)) ? "NA" : (0,general/* parseCountAbbrv2 */.St)(parseInt(String(average), 10));
    }, [
        average
    ]);
    var isNAorZero = (0,react.useMemo)(function() {
        return [
            "NA",
            "0",
            "0.00"
        ].includes(String(formattedAvgVolume));
    }, [
        formattedAvgVolume
    ]);
    var renderPriceTime = function() {
        var ref, ref1, ref2, ref3, ref4;
        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex, {
                    align: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* ResponsiveText */.lz, {
                            as: "h3",
                            family: "bold",
                            margin: "0px",
                            padding: "0px",
                            children: formattedPrice
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* CustomIconmoon */.mJ, {
                            as: "span",
                            className: constants/* priceChange */.lt === null || constants/* priceChange */.lt === void 0 ? void 0 : (ref = constants/* priceChange */.lt[priceType]) === null || ref === void 0 ? void 0 : ref.icon,
                            color: constants/* priceChange */.lt === null || constants/* priceChange */.lt === void 0 ? void 0 : (ref1 = constants/* priceChange */.lt[priceType]) === null || ref1 === void 0 ? void 0 : ref1.color,
                            hoverColor: constants/* priceChange */.lt === null || constants/* priceChange */.lt === void 0 ? void 0 : (ref2 = constants/* priceChange */.lt[priceType]) === null || ref2 === void 0 ? void 0 : ref2.color
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* ResponsiveText */.lz, {
                            as: "h3",
                            color: constants/* priceChange */.lt === null || constants/* priceChange */.lt === void 0 ? void 0 : (ref3 = constants/* priceChange */.lt[priceType]) === null || ref3 === void 0 ? void 0 : ref3.color,
                            px: "5px",
                            children: formattedChange
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* ResponsiveText */.lz, {
                            as: "h3",
                            color: constants/* priceChange */.lt === null || constants/* priceChange */.lt === void 0 ? void 0 : (ref4 = constants/* priceChange */.lt[priceType]) === null || ref4 === void 0 ? void 0 : ref4.color,
                            children: "(".concat(formattedPercentage, "%)")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* TimeText */.LC, {
                    as: "span",
                    color: ui/* color.midgray */.$_.midgray,
                    size: "12px",
                    pt: "3px",
                    children: renderTime()
                })
            ]
        });
    };
    var renderVolume = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* ChartSectionItem */.nJ, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                    as: "h3",
                    size: "16px",
                    children: formattedVolume
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                    color: ui/* color.midgray */.$_.midgray,
                    size: "12px",
                    pt: "3px",
                    children: "Volume"
                })
            ]
        });
    };
    var renderAvgVolume = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* ChartSectionItem */.nJ, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                    as: "h3",
                    size: "16px",
                    children: formattedAvgVolume
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                    color: ui/* color.midgray */.$_.midgray,
                    size: "12px",
                    pt: "3px",
                    children: "Avg volume"
                })
            ]
        });
    };
    var renderTimeframeButtonsMobile = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* TimeframeButtonsMobile */.yX, {
            showTimeframes: showTimeframes,
            timeframe: timeframe,
            onSelectTimeframe: onSelectTimeframe,
            timeFrameList: constants/* chartTimeframes */.Iv
        });
    };
    var renderExpandButtonToggle = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandButtonToggle/* default */.Z, {
            onExpand: onExpand
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex, {
        align: "center",
        justify: "space-between",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex, {
                children: [
                    renderPriceTime(),
                    renderVolume(),
                    !isNAorZero && renderAvgVolume()
                ]
            }),
            renderTimeframeButtonsMobile(),
            renderExpandButtonToggle()
        ]
    });
}
/* harmony default export */ var Chart_ChartDetail = (ChartDetail);

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-chartjs-2/dist/index.modern.js + 1 modules
var index_modern = __webpack_require__(508);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
;// CONCATENATED MODULE: ./src/features/company/Chart/CompanyChart.tsx





var fillColor = ui/* color.clearDay */.$_.clearDay;
var lineColor = ui/* color.mountainMeadow */.$_.mountainMeadow;
function CompanyChart(param) {
    var chart = param.chart, onClickChart = param.onClickChart;
    var ref = chart !== null && chart !== void 0 ? chart : {}, _prices = ref.prices, prices = _prices === void 0 ? [] : _prices, timeframe = ref.timeframe;
    var createPreviousMonth = function(numberOfMonth) {
        var data = [];
        var dateStart = moment_default()().subtract(numberOfMonth, "month");
        var dateEnd = moment_default()();
        while(dateStart.diff(dateEnd, "months") <= 0){
            data.push(dateStart.format("MMM YYYY"));
            dateStart.add(1, "month");
        }
        return data;
    };
    var createPreviousYear = function(numberOfYear) {
        var data = [];
        var dateStart = moment_default()().subtract(numberOfYear, "y");
        var dateEnd = moment_default()();
        while(dateStart.diff(dateEnd, "years") <= 0){
            data.push(dateStart.format("YYYY"));
            dateStart.add(1, "year");
        }
        return data;
    };
    var ref1 = (0,react.useMemo)(function() {
        if (timeframe === "1w") return [
            "DD MMM",
            5,
            []
        ];
        if (timeframe === "1m") return [
            "DD MMM",
            5,
            []
        ];
        if (timeframe === "3m") {
            var previousMonths = createPreviousMonth(2);
            return [
                "MMM",
                3,
                previousMonths
            ];
        }
        if (timeframe === "ytd") return [
            "DD MMM",
            5
        ];
        if (timeframe === "1y") {
            var previousMonths1 = createPreviousMonth(11);
            return [
                "MMM",
                12,
                previousMonths1,
                false
            ];
        }
        if (timeframe === "3y") {
            var previousYear = createPreviousYear(2);
            return [
                "YYYY",
                3,
                previousYear
            ];
        }
        if (timeframe === "5y") {
            var previousYear1 = createPreviousYear(4);
            return [
                "YYYY",
                5,
                previousYear1
            ];
        }
        return [
            "HH:mm",
            6,
            []
        ];
    }, [
        timeframe
    ]), format = ref1[0], maxTicks = ref1[1], labels = ref1[2], tmp = ref1[3], autoSkip = tmp === void 0 ? true : tmp;
    var tempLabels = [];
    var chartData = (0,react.useMemo)(function() {
        return {
            labels: prices.map(function(price) {
                if (!price.formatted_date && price.date === "0") return "";
                var formattedDate = moment_default()(price.formatted_date);
                var monthYear = formattedDate.format("MMM YYYY");
                var month = formattedDate.format("MMM");
                var year = formattedDate.format("YYYY");
                var formattedByTimeframe = formattedDate.format(format);
                switch(timeframe){
                    case "1w":
                        if (formattedDate.hour() <= 9 && !tempLabels.includes(formattedByTimeframe)) {
                            tempLabels.push(formattedByTimeframe);
                            return formattedByTimeframe;
                        }
                        return "";
                    case "1m":
                    case "today":
                        return formattedDate.minute() === 0 ? formattedByTimeframe : "";
                    case "3m":
                    case "1y":
                        if (labels.includes(monthYear)) {
                            labels.splice(labels.indexOf(monthYear), 1);
                            return month;
                        }
                        return "";
                    case "3y":
                    case "5y":
                        if (labels.includes(year)) {
                            labels.splice(labels.indexOf(year), 1);
                            return year;
                        }
                        return "";
                    default:
                        return moment_default()(price.formatted_date).format(format);
                }
            }),
            datasets: [
                {
                    fill: true,
                    tension: 0,
                    backgroundColor: fillColor,
                    borderColor: lineColor,
                    borderCapStyle: "butt",
                    borderDashOffset: 0.0,
                    borderJoinStyle: "round",
                    borderWidth: 2,
                    data: prices.map(function(pr) {
                        return parseInt(pr.value, 10);
                    })
                }, 
            ]
        };
    }, [
        prices,
        format
    ]);
    var options = (0,react.useMemo)(function() {
        return {
            animation: {
                duration: 0
            },
            resizeDelay: 0,
            plugins: {
                legend: {
                    display: false
                },
                tooltip: {
                    enabled: false
                }
            },
            maintainAspectRatio: false,
            scales: {
                y: {
                    position: "right",
                    grid: {
                        display: false,
                        drawBorder: false
                    },
                    ticks: {
                        maxTicksLimit: 8,
                        callback: function callback(val) {
                            var price = val;
                            // if price contain decimal, then hide tick
                            if (typeof price === "number" && price % 1 !== 0) price = null;
                            return price || null;
                        }
                    }
                },
                x: {
                    grid: {
                        display: false
                    },
                    ticks: {
                        align: "start",
                        maxTicksLimit: maxTicks,
                        maxRotation: 0,
                        callback: function callback(val) {
                            return this.getLabelForValue(val) || null;
                        },
                        autoSkip: autoSkip,
                        precision: 0
                    }
                }
            },
            elements: {
                point: {
                    radius: 0
                }
            },
            events: [
                "click"
            ],
            onClick: onClickChart
        };
    }, [
        maxTicks,
        onClickChart
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_modern/* Line */.x1, {
        data: chartData,
        options: options,
        height: 300
    });
}
/* harmony default export */ var Chart_CompanyChart = (CompanyChart);

// EXTERNAL MODULE: ./src/features/company/Chart/EmptyChart.tsx + 1 modules
var EmptyChart = __webpack_require__(19970);
;// CONCATENATED MODULE: ./src/features/company/Chart/MainChart.tsx






function MainChart(param) {
    var visible = param.visible, symbol = param.symbol, timeframe = param.timeframe, showTimeframes = param.showTimeframes, onSelectTimeframe = param.onSelectTimeframe, isLoadingChart = param.isLoadingChart, chart = param.chart, onClickChart = param.onClickChart, disableChartbitLink = param.disableChartbitLink;
    return !visible ? null : /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* MainChartWrapper */.yd, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* TimeframeButtonsDesktop */.Kw, {
                showTimeframes: showTimeframes,
                timeframe: timeframe,
                onSelectTimeframe: onSelectTimeframe,
                timeFrameList: constants/* chartTimeframes */.Iv
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* MainChartContent */.LH, {
                children: [
                    chart && /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* ChartContainer */.BO, {
                        children: disableChartbitLink ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Chart_CompanyChart, {
                            chart: chart,
                            onClickChart: onClickChart
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/symbol/".concat(symbol, "/chartbit"),
                            passHref: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                rel: "noopener noreferrer",
                                target: "_blank",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Chart_CompanyChart, {
                                    chart: chart,
                                    onClickChart: onClickChart
                                })
                            })
                        })
                    }),
                    !isLoadingChart && !chart && /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyChart/* default */.Z, {})
                ]
            })
        ]
    });
}
/* harmony default export */ var Chart_MainChart = (MainChart);

;// CONCATENATED MODULE: ./src/features/company/Chart/index.tsx





function ChartV2(param) {
    var _symbol = param.symbol, symbol = _symbol === void 0 ? "" : _symbol, company = param.company, isLoadingChart = param.isLoadingChart, chart = param.chart, timeframe = param.timeframe, isChartVisible = param.isChartVisible, onSelectTimeFrame = param.onSelectTimeFrame, onExpand = param.onExpand, onClickChart = param.onClickChart, disableChartbitLink = param.disableChartbitLink;
    var showDetail = (0,react.useMemo)(function() {
        var ref;
        var whitelistSectors = [
            "index asing",
            "commodities",
            "fx",
            "crypto",
            "index",
            "reksadana",
            "waran",
            "etf",
            "right", 
        ];
        // Pass if sector is whitelisted
        if (whitelistSectors.includes(company === null || company === void 0 ? void 0 : (ref = company.type_company) === null || ref === void 0 ? void 0 : ref.toLowerCase())) {
            return true;
        }
        return !!chart;
    }, [
        chart,
        company
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* ChartWrapper */.hC, {
        as: "section",
        children: [
            showDetail && /*#__PURE__*/ (0,jsx_runtime.jsx)(Chart_ChartDetail, {
                timeframe: timeframe,
                showTimeframes: isChartVisible,
                symbol: symbol,
                onExpand: onExpand,
                company: company,
                chart: chart,
                onSelectTimeframe: onSelectTimeFrame
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Chart_MainChart, {
                timeframe: timeframe,
                showTimeframes: showDetail,
                symbol: symbol,
                onSelectTimeframe: onSelectTimeFrame,
                visible: isChartVisible,
                isLoadingChart: isLoadingChart,
                chart: chart,
                onClickChart: onClickChart,
                disableChartbitLink: disableChartbitLink
            })
        ]
    });
}
/* harmony default export */ var Chart = (ChartV2);


/***/ }),

/***/ 33263:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$c": function() { return /* binding */ EmptyStateWrapper; },
/* harmony export */   "BO": function() { return /* binding */ ChartContainer; },
/* harmony export */   "Et": function() { return /* binding */ NotHoverIcon; },
/* harmony export */   "Kw": function() { return /* binding */ TimeframeButtonsDesktop; },
/* harmony export */   "LC": function() { return /* binding */ TimeText; },
/* harmony export */   "LH": function() { return /* binding */ MainChartContent; },
/* harmony export */   "f": function() { return /* binding */ ExpandButtonToggleWrapper; },
/* harmony export */   "hC": function() { return /* binding */ ChartWrapper; },
/* harmony export */   "lz": function() { return /* binding */ ResponsiveText; },
/* harmony export */   "mJ": function() { return /* binding */ CustomIconmoon; },
/* harmony export */   "nJ": function() { return /* binding */ ChartSectionItem; },
/* harmony export */   "yX": function() { return /* binding */ TimeframeButtonsMobile; },
/* harmony export */   "yd": function() { return /* binding */ MainChartWrapper; }
/* harmony export */ });
/* unused harmony export CurrentPriceText */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
/* harmony import */ var _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76825);
/* harmony import */ var _TimeframeButtons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5856);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n\n  a {\n    display: flex;\n    height: 100%;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: ",
        ";\n  border: none;\n  padding: 20px;\n\n  > .no-data {\n    padding: 20px 0;\n    text-align: center;\n\n    > .text-empty-state {\n      color: ",
        ";\n      font-size: 13px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 18px;\n      margin-top: 18px;\n    }\n  }\n\n  @media ",
        " {\n    padding: 30px 40px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: ",
        ";\n  border: none;\n  padding: 20px;\n\n  @media ",
        " {\n    border-top: none;\n    padding-top: 8px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  line-height: 1;\n  font-size: 14px;\n\n  &.icon-symbol_up:before {\n    content: '\\25B2';\n    display: inline-block;\n    font-size: 13px;\n    padding-bottom: 4px;\n    padding-left: 5px;\n  }\n  &.icon-symbol_down:before {\n    content: '\\25BC';\n    display: inline-block;\n    font-size: 12px;\n    padding-bottom: 4px;\n    padding-left: 5px;\n  }\n"
    ], [
        "\n  line-height: 1;\n  font-size: 14px;\n\n  &.icon-symbol_up:before {\n    content: '\\\\25B2';\n    display: inline-block;\n    font-size: 13px;\n    padding-bottom: 4px;\n    padding-left: 5px;\n  }\n  &.icon-symbol_down:before {\n    content: '\\\\25BC';\n    display: inline-block;\n    font-size: 12px;\n    padding-bottom: 4px;\n    padding-left: 5px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 14px;\n  letter-spacing: -0.25px;\n\n  @media ",
        " {\n    font-size: 16px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 14px;\n  padding-right: 0;\n  letter-spacing: -0.25px;\n\n  @media ",
        " {\n    font-size: 16px;\n    padding-right: 5px;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: none;\n\n  @media ",
        " {\n    display: block;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: block;\n  padding-left: 30px;\n  text-align: end;\n\n  @media ",
        " {\n    display: none;\n  }\n\n  .text {\n    font-size: 12px;\n    width: 29px;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: none;\n\n  @media ",
        " {\n    display: flex;\n    justify-content: flex-end;\n    margin-bottom: 20px;\n  }\n\n  .text {\n    font-size: 13px;\n    width: 30px;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: none;\n\n  @media ",
        " {\n    display: block;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-top: 20px;\n  padding-top: 8px;\n\n  @media ",
        " {\n    margin-top: 0px;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  min-height: 300px;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: none;\n\n  @media ",
        " {\n    display: block;\n    margin-left: 25px;\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: inline;\n\n  :hover {\n    color: inherit;\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}



var Iconmoon = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Iconmoon */ .Gn.Iconmoon, Text = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Text */ .Gn.Text;
var ChartContainer = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({
    componentId: "sc-f3f6e11e-0"
})(_templateObject());
var EmptyStateWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({
    componentId: "sc-f3f6e11e-1"
})(_templateObject1(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.light */ .$_.light, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.highgray */ .$_.highgray, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device.tablet */ .Uh.tablet);
var ChartWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({
    componentId: "sc-f3f6e11e-2"
})(_templateObject2(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.light */ .$_.light, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device.tablet */ .Uh.tablet);
var CustomIconmoon = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(Iconmoon).withConfig({
    componentId: "sc-f3f6e11e-3"
})(_templateObject3());
var ResponsiveText = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(Text).withConfig({
    componentId: "sc-f3f6e11e-4"
})(_templateObject4(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device.tablet */ .Uh.tablet);
var CurrentPriceText = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(Text).withConfig({
    componentId: "sc-f3f6e11e-5"
})(_templateObject5(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device.tablet */ .Uh.tablet);
var TimeText = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(Text).withConfig({
    componentId: "sc-f3f6e11e-6"
})(_templateObject6(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device.tablet */ .Uh.tablet);
var TimeframeButtonsMobile = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(_TimeframeButtons__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-f3f6e11e-7"
})(_templateObject7(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device.tablet */ .Uh.tablet);
var TimeframeButtonsDesktop = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(_TimeframeButtons__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-f3f6e11e-8"
})(_templateObject8(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device.tablet */ .Uh.tablet);
var ExpandButtonToggleWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({
    componentId: "sc-f3f6e11e-9"
})(_templateObject9(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device.tablet */ .Uh.tablet);
var MainChartWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({
    componentId: "sc-f3f6e11e-10"
})(_templateObject10(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device.tablet */ .Uh.tablet);
var MainChartContent = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({
    componentId: "sc-f3f6e11e-11"
})(_templateObject11());
var ChartSectionItem = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({
    componentId: "sc-f3f6e11e-12"
})(_templateObject12(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device.tablet */ .Uh.tablet);
var NotHoverIcon = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(Iconmoon).withConfig({
    componentId: "sc-f3f6e11e-13"
})(_templateObject13());


/***/ }),

/***/ 89238:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76825);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50489);






var IconWrapper = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.IconWrapper */ .Gn.IconWrapper, Iconmoon = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Iconmoon */ .Gn.Iconmoon, Text = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Text */ .Gn.Text;
function FollowCompanyButton(_param) {
    var isFollowed = _param.isFollowed, onClick = _param.onClick, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "isFollowed",
        "onClick"
    ]);
    var iconName = isFollowed ? "icon-toolbar_check" : "icon-toolbar_plus";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__/* .ButtonFollow */ .qo, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props), {
        onClick: onClick,
        $isFollowed: isFollowed,
        height: "30px",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(IconWrapper, {
            padding: "0 12px 0 8px",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Iconmoon, {
                    className: iconName,
                    size: "14px",
                    isActive: isFollowed,
                    hoverColor: _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.highgray */ .$_.highgray
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Text, {
                    padding: "0 0 0 5px",
                    color: "inherit",
                    children: isFollowed ? "Following" : "Follow"
                })
            ]
        })
    }));
}
/* harmony default export */ __webpack_exports__["Z"] = (FollowCompanyButton);


/***/ }),

/***/ 50489:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AW": function() { return /* binding */ CountryFlag; },
/* harmony export */   "E": function() { return /* binding */ FollowerWrapper; },
/* harmony export */   "GT": function() { return /* binding */ CompanyIdentity; },
/* harmony export */   "Hr": function() { return /* binding */ CountryFlagContainer; },
/* harmony export */   "JQ": function() { return /* binding */ ButtonBuy; },
/* harmony export */   "L$": function() { return /* binding */ MultiplierChip; },
/* harmony export */   "Mw": function() { return /* binding */ ModalFollowing; },
/* harmony export */   "SD": function() { return /* binding */ NotationContainer; },
/* harmony export */   "U7": function() { return /* binding */ ExpandButtonToggleMobile; },
/* harmony export */   "WW": function() { return /* binding */ CatalogButton; },
/* harmony export */   "Y8": function() { return /* binding */ ButtonContainerMobile; },
/* harmony export */   "Yu": function() { return /* binding */ CompanyNameContainer; },
/* harmony export */   "Zc": function() { return /* binding */ ImagePlaceholder; },
/* harmony export */   "a9": function() { return /* binding */ Badges; },
/* harmony export */   "ag": function() { return /* binding */ CompanyHeader; },
/* harmony export */   "cF": function() { return /* binding */ MultiplierContainer; },
/* harmony export */   "cr": function() { return /* binding */ CompanyTags; },
/* harmony export */   "dF": function() { return /* binding */ NotationCorpActionBarWrapper; },
/* harmony export */   "fb": function() { return /* binding */ ImageWrapper; },
/* harmony export */   "gv": function() { return /* binding */ NotationCountryFlagContainer; },
/* harmony export */   "mN": function() { return /* binding */ Symbol; },
/* harmony export */   "n4": function() { return /* binding */ CompanyInfoWrapper; },
/* harmony export */   "qO": function() { return /* binding */ ButtonContainer; },
/* harmony export */   "qo": function() { return /* binding */ ButtonFollow; },
/* harmony export */   "vo": function() { return /* binding */ CountryFlagContainerMobile; },
/* harmony export */   "zo": function() { return /* binding */ CompanyName; }
/* harmony export */ });
/* unused harmony exports Header, ColumnMobile, Percentage, Value, NewNotationTag, NewCorpActionTag, ModalFollowerWrapper, ModalFollowButtonWrapper, FollowerItemWrapper, FollowerModalByDevice */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76825);
/* harmony import */ var global_CorpAction_CorpActionTag__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66988);
/* harmony import */ var global_Image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(579);
/* harmony import */ var global_Notation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15068);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(19521);
/* harmony import */ var features_company_Chart_ExpandButtonToggle__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68068);
/* harmony import */ var global_Moderation_Modals_ModalCompanyWatchlist__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(38654);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: ",
        ";\n  margin-bottom: 20px;\n  padding: 20px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: block;\n  left: -1px;\n  margin: 0;\n  padding: 0;\n  position: relative;\n  top: -1px;\n  width: calc(100% + 2px);\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      /* TODO different color with DS */\n      border: 1px solid rgba(0, 171, 107, 0.5);\n      color: ",
        ";\n\n      &:hover {\n        border: 1px solid rgba(0, 171, 107, 0.5);\n        color: ",
        ";\n      }\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 2px 8px;\n  width: 100px;\n\n  ",
        "\n\n  @media ",
        " {\n    padding: 4px 15px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex-direction: column;\n\n  @media ",
        " {\n    flex-direction: row;\n  }\n\n  &.start-center {\n    align-items: flex-start;\n\n    @media ",
        " {\n      align-items: center;\n    }\n  }\n\n  &.end-center {\n    align-items: flex-end;\n\n    @media ",
        " {\n      align-items: center;\n    }\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  @media ",
        " {\n    margin-left: 5px;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-transform: lowercase;\n  word-wrap: anywhere;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: ",
        ";\n  border-radius: 70px;\n  color: ",
        ";\n  display: flex;\n  margin: auto;\n  min-height: 54px;\n  min-width: 54px;\n\n  > small {\n    font-family: 'Proxima Nova', sans-serif;\n    font-size: 20px;\n    font-weight: 700;\n    line-height: 27px;\n    margin: auto;\n    text-align: center;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: inline-block;\n  font-family: 'ProximaNovaBd';\n  font-size: 16px;\n  margin: 0;\n  max-width: calc(100% - 30px);\n  overflow: hidden;\n  padding: 0;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: inline-block;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: 1px solid ",
        ";\n  border-radius: 50%;\n  display: none;\n  height: 18px;\n  margin-left: 10px;\n  width: 18px;\n\n  @media ",
        " {\n    display: inline-block;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: inline-block;\n  height: 24px;\n  width: 24px;\n\n  @media ",
        " {\n    display: none;\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-radius: 2px;\n  display: inline-block;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: normal;\n  position: relative;\n  top: -4px;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: ",
        ";\n  /* TODO different color with DS */\n  border: solid 1px rgba(238, 74, 73, 0.5);\n  border-radius: 2px;\n  color: ",
        ";\n  display: inline-block;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: normal;\n  margin-left: 8px;\n  padding: 0px 5px;\n  position: relative;\n  top: -5px;\n  vertical-align: middle;\n\n  > span {\n    font-style: normal;\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-bottom: 5px;\n\n  > h1 {\n    color: ",
        ";\n    font-family: 'ProximaNovaRg';\n    font-size: 14px;\n    line-height: 15px;\n    margin: 0;\n    padding: 0;\n  }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-top: 3px;\n  width: 100%;\n\n  span.catalogs {\n    display: inline-block;\n    font-family: 'ProximaNovaRg';\n    font-size: 16px;\n    font-weight: 700;\n    max-width: calc(100% - 30px);\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  a {\n    color: ",
        ";\n    display: block;\n    font-size: 12px;\n    font-weight: normal;\n    max-width: 100%;\n    overflow: hidden;\n    padding-right: 7px;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 0;\n  position: relative;\n\n  span.catalogs {\n    display: none;\n    margin-bottom: 5px;\n    margin-right: 5px;\n    text-align: center;\n  }\n\n  span:first-child {\n    display: inline-block;\n  }\n\n  a {\n    display: block;\n    font-weight: normal;\n    padding: 2px 0;\n  }\n\n  /* TODO different device type with DS */\n  @media (min-width: 1081px) {\n    /* TODO different color with DS */\n    span.catalogs {\n      border: 1px solid rgba(0, 171, 107, 0.3);\n      border-radius: 2px;\n      display: inline-block;\n      padding: 0 5px;\n    }\n  }\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  justify-content: space-between;\n  margin: 0;\n  width: 100%;\n\n  @media ",
        " {\n    margin: auto;\n    width: auto;\n  }\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-items: flex-start;\n  background: ",
        ";\n  border: none;\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  gap: 15px;\n  height: auto;\n  line-height: 1.15;\n  min-height: 65px;\n  padding: ",
        ";\n  position: relative;\n\n  @media ",
        " {\n    align-items: center;\n    flex-direction: row;\n    width: calc(100% - 355px);\n  }\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: inline-block;\n  margin-left: 4px;\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: inline-block;\n  margin-left: 4px;\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: block;\n  position: absolute;\n  top: 89px;\n  right: 20px;\n\n  @media ",
        " {\n    display: none;\n    position: relative;\n  }\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n          background-color: ",
        ";\n          flex-direction: column;\n\n          > a {\n            width: 100%;\n          }\n\n          @media ",
        " {\n            flex-direction: row;\n\n            > div {\n              flex-basis: ",
        ";\n            }\n\n            > a {\n              flex-basis: ",
        ";\n            }\n          }\n        "
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n          background-color: transparent;\n        "
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: none;\n\n  @media ",
        " {\n    cursor: pointer;\n    display: block;\n    margin-right: 10px;\n\n    :hover {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n"
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 24px;\n  padding: unset;\n  width: 100px;\n"
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: 1px solid transparent;\n  border-width: 1px 0;\n  padding: 10px 15px;\n\n  :hover {\n    border-color: ",
        ";\n  }\n\n  @media ",
        " {\n    padding: 10px 50px;\n  }\n"
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  @media ",
        " {\n    .ant-modal-content {\n      width: 660px;\n    }\n  }\n"
    ]);
    _templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: auto;\n\n  @media ",
        " {\n    width: 100px;\n  }\n"
    ]);
    _templateObject31 = function _templateObject31() {
        return data;
    };
    return data;
}
function _templateObject32() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-items: center;\n  border: none;\n  background: #ffffff;\n\n  @media ",
        " {\n    border-bottom: 1px solid ",
        ";\n  }\n"
    ]);
    _templateObject32 = function _templateObject32() {
        return data;
    };
    return data;
}
function _templateObject33() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: none;\n\n  @media ",
        " {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    min-height: 65px;\n    padding: 17.5px 20px 12.5px 0px;\n    width: 355px;\n  }\n"
    ]);
    _templateObject33 = function _templateObject33() {
        return data;
    };
    return data;
}
function _templateObject34() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n\n  @media ",
        " {\n    display: none;\n  }\n"
    ]);
    _templateObject34 = function _templateObject34() {
        return data;
    };
    return data;
}
function _templateObject35() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject35 = function _templateObject35() {
        return data;
    };
    return data;
}
function _templateObject36() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: inline-block;\n  margin-left: 8px;\n  top: -5px;\n  position: relative;\n"
    ]);
    _templateObject36 = function _templateObject36() {
        return data;
    };
    return data;
}
function _templateObject37() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  border: 1px solid #8277f8;\n  border-radius: 2px;\n  height: 16px;\n  padding: 0 4.5px 0 2px;\n  color: #8277f8;\n  background-color: #f5f0ff;\n"
    ]);
    _templateObject37 = function _templateObject37() {
        return data;
    };
    return data;
}
function _templateObject38() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  white-space: nowrap;\n"
    ]);
    _templateObject38 = function _templateObject38() {
        return data;
    };
    return data;
}







var Button = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Button */ .Gn.Button, Flex = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Flex */ .Gn.Flex, Text = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Text */ .Gn.Text;
var ModalCompany = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Company.ModalCompany */ .YD.ModalCompany;
var Header = styled_components__WEBPACK_IMPORTED_MODULE_7__["default"].div.withConfig({
    componentId: "sc-e7160b3b-0"
})(_templateObject(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.light */ .$_.light);
var CompanyHeader = styled_components__WEBPACK_IMPORTED_MODULE_7__["default"].section.withConfig({
    componentId: "sc-e7160b3b-1"
})(_templateObject1());
// eslint-disable-next-line space-infix-ops
var CountryFlag = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__["default"])(global_Image__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-e7160b3b-2"
})(_templateObject2());
var ButtonFollow = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__["default"])(Button).withConfig({
    componentId: "sc-e7160b3b-3"
})(_templateObject4(), function(props) {
    return props.$isFollowed && (0,styled_components__WEBPACK_IMPORTED_MODULE_7__.css)(_templateObject3(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.primary */ .$_.primary, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.primary */ .$_.primary);
}, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device.tablet */ .Uh.tablet);
var ColumnMobile = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__["default"])(Flex).withConfig({
    componentId: "sc-e7160b3b-4"
})(_templateObject5(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device.tablet */ .Uh.tablet, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device.tablet */ .Uh.tablet, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device.tablet */ .Uh.tablet);
var Percentage = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__["default"])(Text).attrs({
    size: "13px",
    family: "bold"
}).withConfig({
    componentId: "sc-e7160b3b-5"
})(_templateObject6(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device.tablet */ .Uh.tablet);
var Value = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__["default"])(Text).attrs({
    size: "18px",
    color: _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.black */ .$_.black,
    family: "bold"
}).withConfig({
    componentId: "sc-e7160b3b-6"
})(_templateObject7());
/* TODO different color with DS */ var IMAGE_PLACEHOLDER_COLOR = "#3A645C";
var ImagePlaceholder = styled_components__WEBPACK_IMPORTED_MODULE_7__["default"].span.withConfig({
    componentId: "sc-e7160b3b-7"
})(_templateObject8(), IMAGE_PLACEHOLDER_COLOR, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.light */ .$_.light);
var Symbol = styled_components__WEBPACK_IMPORTED_MODULE_7__["default"].h3.withConfig({
    componentId: "sc-e7160b3b-8"
})(_templateObject9());
var NotationCountryFlagContainer = styled_components__WEBPACK_IMPORTED_MODULE_7__["default"].div.withConfig({
    componentId: "sc-e7160b3b-9"
})(_templateObject10());
var CountryFlagContainer = styled_components__WEBPACK_IMPORTED_MODULE_7__["default"].span.withConfig({
    componentId: "sc-e7160b3b-10"
})(_templateObject11(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.veryLightGrey */ .$_.veryLightGrey, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device.tablet */ .Uh.tablet);
var CountryFlagContainerMobile = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__["default"])(CountryFlagContainer).withConfig({
    componentId: "sc-e7160b3b-11"
})(_templateObject12(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device.tablet */ .Uh.tablet);
var NotationContainer = styled_components__WEBPACK_IMPORTED_MODULE_7__["default"].div.withConfig({
    componentId: "sc-e7160b3b-12"
})(_templateObject13());
var Badges = styled_components__WEBPACK_IMPORTED_MODULE_7__["default"].div.withConfig({
    componentId: "sc-e7160b3b-13"
})(_templateObject14(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.light */ .$_.light, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.sunsetOrange */ .$_.sunsetOrange);
var CompanyName = styled_components__WEBPACK_IMPORTED_MODULE_7__["default"].div.withConfig({
    componentId: "sc-e7160b3b-14"
})(_templateObject15(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.highgray */ .$_.highgray);
var CompanyNameContainer = styled_components__WEBPACK_IMPORTED_MODULE_7__["default"].section.withConfig({
    componentId: "sc-e7160b3b-15"
})(_templateObject16(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.primary */ .$_.primary);
var CompanyTags = styled_components__WEBPACK_IMPORTED_MODULE_7__["default"].div.withConfig({
    componentId: "sc-e7160b3b-16"
})(_templateObject17());
var ImageWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__["default"])(Flex).withConfig({
    componentId: "sc-e7160b3b-17"
})(_templateObject18(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device.tablet */ .Uh.tablet);
var CompanyInfoWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__["default"])(Flex).withConfig({
    componentId: "sc-e7160b3b-18"
})(_templateObject19(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.light */ .$_.light, function(props) {
    return props.$isIconAvailable ? "15px 10px 12px 20px" : "10px 10px 10px 20px";
}, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device.tablet */ .Uh.tablet);
var NewNotationTag = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__["default"])(global_Notation__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
    componentId: "sc-e7160b3b-19"
})(_templateObject20());
var NewCorpActionTag = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__["default"])(global_CorpAction_CorpActionTag__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-e7160b3b-20"
})(_templateObject21());
var ExpandButtonToggleMobile = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__["default"])(features_company_Chart_ExpandButtonToggle__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).withConfig({
    componentId: "sc-e7160b3b-21"
})(_templateObject22(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device.tablet */ .Uh.tablet);
var NotationCorpActionBarWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__["default"])(Flex).withConfig({
    componentId: "sc-e7160b3b-22"
})(_templateObject25(), function(param) {
    var isCompanyStock = param.isCompanyStock, isBoth = param.isBoth;
    return isCompanyStock ? (0,styled_components__WEBPACK_IMPORTED_MODULE_7__.css)(_templateObject23(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.light */ .$_.light, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device.tablet */ .Uh.tablet, isBoth ? "50%" : "auto", isBoth ? "50%" : "auto") : (0,styled_components__WEBPACK_IMPORTED_MODULE_7__.css)(_templateObject24());
});
var FollowerWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__["default"])(Text).attrs({
    color: _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.midgray */ .$_.midgray,
    size: "12px"
}).withConfig({
    componentId: "sc-e7160b3b-23"
})(_templateObject26(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device.tablet */ .Uh.tablet, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.midgray */ .$_.midgray);
var ModalFollowerWrapper = styled_components__WEBPACK_IMPORTED_MODULE_7__["default"].div.withConfig({
    componentId: "sc-e7160b3b-24"
})(_templateObject27());
var ModalFollowButtonWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__["default"])(Button).withConfig({
    componentId: "sc-e7160b3b-25"
})(_templateObject28());
var FollowerItemWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__["default"])(Flex).attrs({
    justify: "space-between",
    align: "center"
}).withConfig({
    componentId: "sc-e7160b3b-26"
})(_templateObject29(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.aliceBlue */ .$_.aliceBlue, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device.tablet */ .Uh.tablet);
var FollowerModalByDevice = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__["default"])(ModalCompany).attrs({
    type: "fullscreen"
}).withConfig({
    componentId: "sc-e7160b3b-27"
})(_templateObject30(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device.tablet */ .Uh.tablet);
var ButtonBuy = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__["default"])(Button).attrs({
    type: "primary",
    height: "30px",
    ml: "10px"
}).withConfig({
    componentId: "sc-e7160b3b-28"
})(_templateObject31(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device.tablet */ .Uh.tablet);
var CompanyIdentity = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__["default"])(Flex).withConfig({
    componentId: "sc-e7160b3b-29"
})(_templateObject32(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device.tablet */ .Uh.tablet, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.gainsboro */ .$_.gainsboro);
var ButtonContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__["default"])(Flex).withConfig({
    componentId: "sc-e7160b3b-30"
})(_templateObject33(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device.tablet */ .Uh.tablet);
var ButtonContainerMobile = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__["default"])(ButtonContainer).withConfig({
    componentId: "sc-e7160b3b-31"
})(_templateObject34(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device.tablet */ .Uh.tablet);
var ModalFollowing = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__["default"])(global_Moderation_Modals_ModalCompanyWatchlist__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).attrs({
    maskStyle: {
        backgroundColor: "rgba(0,0,0,0.8)"
    }
}).withConfig({
    componentId: "sc-e7160b3b-32"
})(_templateObject35());
var MultiplierContainer = styled_components__WEBPACK_IMPORTED_MODULE_7__["default"].div.withConfig({
    componentId: "sc-e7160b3b-33"
})(_templateObject36());
var MultiplierChip = styled_components__WEBPACK_IMPORTED_MODULE_7__["default"].div.withConfig({
    componentId: "sc-e7160b3b-34"
})(_templateObject37());
var CatalogButton = styled_components__WEBPACK_IMPORTED_MODULE_7__["default"].a.withConfig({
    componentId: "sc-e7160b3b-35"
})(_templateObject38());


/***/ }),

/***/ 67462:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ company_Navbar; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@stockbit/ui/index.js
var ui = __webpack_require__(76825);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/constants/data-cy.ts
var data_cy = __webpack_require__(70524);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/antd/es/tooltip/index.js + 5 modules
var tooltip = __webpack_require__(36084);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/features/company/Navbar/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  margin-bottom: 20px;\n  position: relative;\n  width: 100%;\n\n  > .navbar-company {\n    position: relative;\n\n    > div:first-child {\n      position: static;\n      width: 100%;\n\n      & > a {\n        border-bottom: 1px solid ",
        ";\n        flex: 1 0 auto;\n        width: calc((100% - 45px) / 2);\n\n        @media ",
        " {\n          width: calc((100% - 45px) / 3);\n        }\n\n        @media ",
        " {\n          width: calc((100% - 45px) / 4);\n        }\n\n        @media ",
        " {\n          width: calc((100% - 45px) / 6);\n        }\n  \n        @media ",
        " {\n          width: calc((100% - 45px) / 8) !important;\n        }\n      }\n    }\n\n    > div:last-child {\n      > div:first-child {\n        border-right: none;\n      }\n\n      > div:last-child {\n        border-right: 1px solid ",
        ";\n        border-top: 1px solid ",
        ";\n        padding: 0;\n        right: -1px;\n        z-index: 99;\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      background-color: ",
        ";\n      color: ",
        " !important;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        " !important;\n  cursor: pointer;\n  text-transform: capitalize;\n\n  ",
        "\n\n  :hover {\n    color: ",
        " !important;\n  }\n\n  .analyst-tooltip {\n    max-width: none;\n    z-index: 99;\n  }\n\n  .ant-tooltip-inner {\n    align-items: center;\n    background-color: ",
        ";\n    border-radius: 4px;\n    cursor: pointer;\n    display: flex;\n    font-size: 14px;\n    justify-content: center;\n    margin: 0;\n    max-width: 350px;\n    padding: 0;\n  }\n\n  .ant-tooltip-arrow {\n    border-bottom-color: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  color: ",
        ";\n  display: flex;\n  height: 34px;\n  justify-content: center;\n  padding: 8px 10px;\n  text-decoration: none;\n  text-transform: none;\n\n  :hover {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .analyst-tooltip {\n    max-width: none;\n    z-index: 99;\n  }\n\n  .ant-tooltip-inner {\n    align-items: center;\n    background-color: ",
        ";\n    border-radius: 4px;\n    cursor: pointer;\n    display: flex;\n    font-size: 14px;\n    justify-content: center;\n    margin: 0;\n    max-width: 350px;\n    padding: 0;\n  }\n\n  .ant-tooltip-arrow {\n    border-bottom-color: ",
        ";\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}



var Text = ui/* Common.Text */.Gn.Text;
var NavbarWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-a351a00b-0"
})(_templateObject(), ui/* color.light */.$_.light, ui/* color.gainsboro */.$_.gainsboro, ui/* device.mobileS */.Uh.mobileS, ui/* device.mobileL */.Uh.mobileL, ui/* device.tablet */.Uh.tablet, ui/* device.laptop */.Uh.laptop, ui/* color.gainsboro */.$_.gainsboro, ui/* color.gainsboro */.$_.gainsboro);
var NavLink = (0,styled_components_browser_esm["default"])(Text).attrs({
    align: "center",
    as: "a",
    height: "40px",
    padding: "0 12px"
}).withConfig({
    componentId: "sc-a351a00b-1"
})(_templateObject2(), ui/* color.highempahis */.$_.highempahis, function(param) {
    var isActive = param.isActive;
    return isActive && (0,styled_components_browser_esm.css)(_templateObject1(), ui/* color.aliceBlue */.$_.aliceBlue, ui/* color.primary */.$_.primary);
}, ui/* color.primary */.$_.primary, ui/* color.primary */.$_.primary, ui/* color.primary */.$_.primary);
var TooltipLink = styled_components_browser_esm["default"].a.withConfig({
    componentId: "sc-a351a00b-2"
})(_templateObject3(), ui/* color.light */.$_.light, ui/* color.light */.$_.light);
var AnalystTooltip = (0,styled_components_browser_esm["default"])(tooltip/* default */.Z).withConfig({
    componentId: "sc-a351a00b-3"
})(_templateObject4(), ui/* color.primary */.$_.primary, ui/* color.primary */.$_.primary);


// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/features/company/constants.ts
var constants = __webpack_require__(55564);
;// CONCATENATED MODULE: ./src/features/company/Navbar/index.tsx









var _NavbarCompany = ui/* Company.NavbarCompany */.YD.NavbarCompany, NavBarComponent = _NavbarCompany.NavBarComponent, NavMoreLogo = _NavbarCompany.NavMoreLogo;
var PATH_ANALYST = constants/* TAB_LIST */.YS[constants/* TAB_LIST_NAME.ANALYST */.p.ANALYST].path;
var TOOLTIP_ANALYST_TEXT = "Kompilasi target analyst dari berbagai sekuritas";
function Navbar(param) {
    var active = param.active, tabs = param.tabs, _isCompanyStock = param.isCompanyStock, isCompanyStock = _isCompanyStock === void 0 ? false : _isCompanyStock, className = param.className, _isLoggedIn = param.isLoggedIn, isLoggedIn = _isLoggedIn === void 0 ? false : _isLoggedIn, _userId = param.userId, userId = _userId === void 0 ? "" : _userId, onClickTab = param.onClickTab, _onSendClevertapEvent = param.onSendClevertapEvent, onSendClevertapEvent = _onSendClevertapEvent === void 0 ? function() {} : _onSendClevertapEvent;
    var router = (0,next_router.useRouter)();
    var symbol = router.query.symbol;
    var ref = (0,react.useState)(false), isShowingAnalystTooltip = ref[0], setIsShowingAnalystTooltip = ref[1];
    var returnNotLogin = function() {
        if (isCompanyStock) {
            onClickTab(true);
        } else {
            router.push("/register");
        }
    };
    var onSelectTab = function(event, param) {
        var path = param.path;
        event.preventDefault();
        itemNavigationOnClick(getPathName(path));
        if (isLoggedIn) {
            router.push("/symbol/".concat(symbol).concat(path), undefined, {
                scroll: false
            });
        } else {
            returnNotLogin();
        }
    };
    var getPathName = function(path) {
        try {
            return path.slice(1);
        } catch (_error) {
            return path;
        }
    };
    var checkIsActive = function(value) {
        // Make stream active if path is /buy and value is empty
        if (active === constants/* TAB_LIST_NAME.BUY */.p.BUY && value === "") return true;
        return active === getPathName(value);
    };
    var getAnalystUserIds = function() {
        var analystUserIds = localStorage.getItem("analystUserIds");
        var analystUserIdsArray = [];
        if (!!analystUserIds) {
            analystUserIdsArray = analystUserIds.split(",");
        }
        return analystUserIdsArray;
    };
    var setAnalystUserIds = function(analystUserIds) {
        var newAnalystUserIds = (0,_to_consumable_array/* default */.Z)(analystUserIds);
        newAnalystUserIds.push(String(userId));
        localStorage.setItem("analystUserIds", newAnalystUserIds.join());
    };
    var isUserIdExistsInAnalystUserIds = function(analystUserIds) {
        return analystUserIds.includes(String(userId));
    };
    var onCloseAnalystTooltip = function() {
        // Update analystUserIds
        var analystUserIds = getAnalystUserIds();
        if (!isUserIdExistsInAnalystUserIds(analystUserIds)) {
            setAnalystUserIds(analystUserIds);
        }
        // Hide Analyst Tooltip
        setIsShowingAnalystTooltip(false);
    };
    var itemNavigationOnClick = function(itemName) {
        if (itemName === constants/* TAB_LIST_NAME.ANALYST */.p.ANALYST) {
            onCloseAnalystTooltip();
        }
        // need to set timeout for sending clevertap event due to
        // RaceCondition issue between Http Request & Switching Page route
        onSendClevertapEvent({
            tabPath: itemName,
            timeout: 500
        });
    };
    var isLoggedInAndHaveUserId = isLoggedIn && !!userId;
    var shouldShowAnalystTooltip = function(analystUserIds) {
        return isLoggedInAndHaveUserId && !isUserIdExistsInAnalystUserIds(analystUserIds) && !isShowingAnalystTooltip;
    };
    (0,react.useEffect)(function() {
        var analystUserIds = getAnalystUserIds();
        if (shouldShowAnalystTooltip(analystUserIds)) {
            setIsShowingAnalystTooltip(true);
        }
    }, [
        userId,
        active
    ]);
    var MoreMenu = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            "data-cy": data_cy/* default.COMPANY.NAVBAR_MORE_MENU */.Z.COMPANY.NAVBAR_MORE_MENU,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavMoreLogo, {})
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NavbarWrapper, {
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavBarComponent, {
            className: "navbar-company",
            expandNavLogo: MoreMenu,
            children: tabs.map(function(item, index) {
                return item.path === PATH_ANALYST ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AnalystTooltip, {
                    placement: "bottom",
                    visible: isShowingAnalystTooltip,
                    overlayClassName: "analyst-tooltip",
                    color: ui/* color.primary */.$_.primary,
                    getPopupContainer: function(triggerNode) {
                        return triggerNode;
                    },
                    title: function() {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/symbol/".concat(symbol).concat(item.path),
                            passHref: true,
                            scroll: false,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipLink, {
                                onClick: function() {
                                    return itemNavigationOnClick(getPathName(item.path));
                                },
                                children: TOOLTIP_ANALYST_TEXT
                            })
                        });
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/symbol/".concat(symbol).concat(item.path),
                        passHref: true,
                        scroll: false,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavLink, {
                            onClick: function(e) {
                                return onSelectTab(e, item);
                            },
                            isActive: checkIsActive(item.path),
                            children: item.label
                        }, index)
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/symbol/".concat(symbol).concat(item.path),
                    passHref: true,
                    scroll: false,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavLink, {
                        onClick: function(e) {
                            return onSelectTab(e, item);
                        },
                        isActive: checkIsActive(item.path),
                        children: item.label
                    }, index)
                });
            })
        })
    });
}
/* harmony default export */ var company_Navbar = (Navbar);


/***/ }),

/***/ 55564:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Iv": function() { return /* binding */ chartTimeframes; },
/* harmony export */   "K1": function() { return /* binding */ TAB_ANALYST_NEW_NAME; },
/* harmony export */   "PV": function() { return /* binding */ CHART_COLOR; },
/* harmony export */   "R1": function() { return /* binding */ SOURCE_MENU; },
/* harmony export */   "YS": function() { return /* binding */ TAB_LIST; },
/* harmony export */   "hW": function() { return /* binding */ FR_CHART_TYPES; },
/* harmony export */   "l3": function() { return /* binding */ SENTIMENT_INDICATOR_COLORS; },
/* harmony export */   "lt": function() { return /* binding */ priceChange; },
/* harmony export */   "p": function() { return /* binding */ TAB_LIST_NAME; },
/* harmony export */   "rn": function() { return /* binding */ chartTimeframesFR; },
/* harmony export */   "sX": function() { return /* binding */ CORP_ACTIONS; },
/* harmony export */   "wm": function() { return /* binding */ CORP_ACTION_NAVS; }
/* harmony export */ });
/* unused harmony exports TAB_CORP_ACTION_NEW_NAME, CLEVERTAP_ANALYST, CLEVERTAP_SEASONALITY */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36305);
/* harmony import */ var _stockbit_ui__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76825);
/* harmony import */ var _types_company_d__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82964);





var CORP_ACTIONS = {
    dividend: "Dividend",
    stocksplit: "Stock Split",
    reversesplit: "Reverse Split",
    rightissue: "Right Issue",
    warrant: "Warrant",
    bonus: "Bonus",
    tenderoffer: "Tender Offer",
    pubex: "Pubex",
    rups: "RUPS"
};
var CORP_ACTION_NAVS = [
    {
        value: "all",
        label: "All"
    }, 
].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(Object.entries(CORP_ACTIONS).map(function(param) {
    var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(param, 2), value = _param[0], label = _param[1];
    return {
        value: value,
        label: label
    };
})));
var chartTimeframes = [
    {
        value: "today",
        label: "1D"
    },
    {
        value: "1w",
        label: "1W"
    },
    {
        value: "1m",
        label: "1M"
    },
    {
        value: "3m",
        label: "3M"
    },
    {
        value: "ytd",
        label: "YTD"
    },
    {
        value: "1y",
        label: "1Y"
    },
    {
        value: "3y",
        label: "3Y"
    },
    {
        value: "5y",
        label: "5Y"
    }, 
];
var priceChange = {
    netral: {
        icon: "",
        color: _stockbit_ui__WEBPACK_IMPORTED_MODULE_0__/* .color.nobel */ .$_.nobel
    },
    up: {
        icon: "icon-symbol_up",
        color: _stockbit_ui__WEBPACK_IMPORTED_MODULE_0__/* .color.primary */ .$_.primary
    },
    down: {
        icon: "icon-symbol_down",
        color: _stockbit_ui__WEBPACK_IMPORTED_MODULE_0__/* .color.sunsetOrange */ .$_.sunsetOrange
    }
};
var SENTIMENT_INDICATOR_COLORS = [
    {
        background: _stockbit_ui__WEBPACK_IMPORTED_MODULE_0__/* .color.royalBlue */ .$_.royalBlue,
        label: "Pessimistic"
    },
    {
        background: _stockbit_ui__WEBPACK_IMPORTED_MODULE_0__/* .color.steelBlue */ .$_.steelBlue,
        label: "Cautious"
    },
    {
        background: _stockbit_ui__WEBPACK_IMPORTED_MODULE_0__/* .color.scooter */ .$_.scooter,
        label: "Neutral"
    },
    {
        background: _stockbit_ui__WEBPACK_IMPORTED_MODULE_0__/* .color.java */ .$_.java,
        label: "Optimstic"
    },
    {
        background: _stockbit_ui__WEBPACK_IMPORTED_MODULE_0__/* .color.jade */ .$_.jade,
        label: "Positive"
    }, 
];
var CHART_COLOR = [
    "#3366FF",
    "#ff00ff",
    "#ff7900",
    "#008700",
    "#ff0000",
    "#1c1cb5",
    "#00ff00",
    "#7f33ba",
    "#e83535",
    "#800000",
    "#666666",
    "#000000", 
];
var TAB_LIST_NAME = _types_company_d__WEBPACK_IMPORTED_MODULE_1__/* .TabListNameEnums */ .A;
var _obj;
var TAB_LIST = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, TAB_LIST_NAME.STREAM, {
    label: "Stream",
    path: "",
    isNewFeature: false
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, TAB_LIST_NAME.NEWS, {
    label: "News",
    path: "/news",
    isNewFeature: false
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, TAB_LIST_NAME.KEYSTATS, {
    label: "Key Stats",
    path: "/keystats",
    isNewFeature: false
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, TAB_LIST_NAME.ANALYST, {
    label: "Analysis",
    path: "/analyst",
    isNewFeature: true
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, TAB_LIST_NAME.FINANCIALS, {
    label: "Financials",
    path: "/financials",
    isNewFeature: false
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, TAB_LIST_NAME.FUNDACHART, {
    label: "Fundachart",
    path: "/fundachart",
    isNewFeature: false
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, TAB_LIST_NAME.SEASONALITY, {
    label: "Seasonality",
    path: "/seasonality",
    isNewFeature: false
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, TAB_LIST_NAME.CHARTBIT, {
    label: "Chartbit",
    path: "/chartbit",
    isNewFeature: false
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, TAB_LIST_NAME.COMPARISON, {
    label: "Comparison",
    path: "/comparison",
    isNewFeature: false
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, TAB_LIST_NAME.INSIDER, {
    label: "Insider",
    path: "/insider",
    isNewFeature: true
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, TAB_LIST_NAME.PROFILE, {
    label: "Profile",
    path: "/profile",
    isNewFeature: false
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, TAB_LIST_NAME.CORP_ACTION, {
    label: "Corp. Action",
    path: "/corpaction",
    isNewFeature: false
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, TAB_LIST_NAME.CONSENSUS, {
    label: "EPS Estimate",
    path: "/consensus",
    isNewFeature: false
}), _obj);
var TAB_ANALYST_NEW_NAME = "analysis";
var TAB_CORP_ACTION_NEW_NAME = "corpaction";
var CLEVERTAP_ANALYST = "Analyst Ratings - Tab Menu Selected";
var CLEVERTAP_SEASONALITY = "Seasonality - Tab Menu Selected";
var SOURCE_MENU = "Menu";
var FR_CHART_TYPES = [
    {
        value: "yield",
        label: "Yield"
    },
    {
        value: "buy_price_rate",
        label: "Harga Beli"
    },
    {
        value: "sell_price_rate",
        label: "Harga Jual"
    }, 
];
var chartTimeframesFR = [
    {
        value: "1d",
        label: "1D"
    },
    {
        value: "1m",
        label: "1M"
    },
    {
        value: "3m",
        label: "3M"
    },
    {
        value: "ytd",
        label: "YTD"
    },
    {
        value: "1y",
        label: "1Y"
    },
    {
        value: "3y",
        label: "3Y"
    },
    {
        value: "5y",
        label: "5Y"
    },
    {
        value: "all",
        label: "All"
    }, 
];



/***/ }),

/***/ 88679:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76825);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _CorpActionTag__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66988);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27691);
/* eslint-disable no-undef */ 




var Flex = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Flex */ .Gn.Flex, Text = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Text */ .Gn.Text;
function CorpActionBar(param) {
    var symbol = param.symbol, corpAction = param.corpAction, _isGuestCompanyStock = param.isGuestCompanyStock, isGuestCompanyStock = _isGuestCompanyStock === void 0 ? false : _isGuestCompanyStock, onClick = param.onClick;
    var onClickLink = function(event) {
        isGuestCompanyStock ? onClick(event) : false;
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: "/symbol/".concat(symbol, "/corpaction"),
        passHref: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            onClick: onClickLink,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_4__/* .BarWrapper */ .iG, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Flex, {
                        align: "center",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CorpActionTag__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                corpAction: corpAction
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Text, {
                                as: "span",
                                color: _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.highempahis */ .$_.highempahis,
                                weight: "600",
                                ml: "8px",
                                size: "12px",
                                children: "Perusahaan memiliki Corporate Action"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_4__/* .IconArrow */ .CC, {
                        as: "span"
                    })
                ]
            })
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (CorpActionBar);


/***/ }),

/***/ 52491:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76825);
/* harmony import */ var global_Image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(579);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _Content__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92292);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(97038);






var Flex = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Flex */ .Gn.Flex, Text = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Text */ .Gn.Text;
var INDICATOR_ICON_URL = "/icon/ic_indicator.svg";
function IndicatorBar(param) {
    var symbol = param.symbol, uma = param.uma, notation = param.notation, name = param.name, _type = param.type, type = _type === void 0 ? "indicator" : _type, _isGuestCompanyStock = param.isGuestCompanyStock, isGuestCompanyStock = _isGuestCompanyStock === void 0 ? false : _isGuestCompanyStock, onClick = param.onClick;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), isVisible = ref[0], setVisible = ref[1];
    var onCloseModal = function() {
        return setVisible(false);
    };
    var onOpenModal = function() {
        return setVisible(true);
    };
    var onClickBar = function(event) {
        isGuestCompanyStock ? onClick(event) : onOpenModal();
    };
    var renderTag = function(isNotationBadges) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_5__/* .NotationTag */ .GU, {
            type: type,
            isSmall: true,
            isNotationBadges: isNotationBadges,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                alt: "indikator notasi khusus",
                src: INDICATOR_ICON_URL
            })
        });
    };
    var notationList = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
        return notation.map(function(item) {
            return item === null || item === void 0 ? void 0 : item.notation_code;
        });
    }, [
        notation
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_5__/* .NotationBar */ .H_, {
                align: "center",
                justify: "space-between",
                px: "18px",
                onClick: onClickBar,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Flex, {
                        align: "center",
                        justify: "flex-start",
                        children: [
                            renderTag(true),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Text, {
                                as: "span",
                                weight: "600",
                                size: "11px",
                                height: "13.4px",
                                ml: "8px",
                                family: "bold",
                                mr: "6px",
                                children: "Perusahaan memiliki Notasi Khusus"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_5__/* .NotationBadgeContainer */ .Nj, {
                                children: notationList.map(function(code, index) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                        children: [
                                            code,
                                            index < notationList.length - 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                                src: "/icon/notsus-badge-dot.svg"
                                            })
                                        ]
                                    });
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Flex, {
                        align: "center",
                        justify: "flex-end",
                        style: {
                            cursor: "pointer"
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_5__/* .IconArrow */ .CC, {
                            as: "span"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_5__/* .ModalIndicatorBar */ .Qu, {
                visible: isVisible,
                onCancel: onCloseModal,
                title: null,
                centered: true,
                width: "520px",
                bodyStyle: {
                    padding: "16px"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Content__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    symbol: symbol,
                    uma: uma,
                    notation: notation,
                    name: name,
                    notationTag: renderTag(true),
                    isFullsize: true
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (IndicatorBar);


/***/ }),

/***/ 42826:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/**
 * Upload image handler
 * @param file - File to be uploaded
 * @param url - AWS Bucket URL
 * @param awsFields - Additional aws fields from `getPolicy` API
 * @param - type upload chat|stream
 * @returns {Promise<*>} fetch function
 */ var uploadHandler = function(file, url, awsFields, type) {
    return new Promise(function(resolve, reject) {
        var fd = new FormData();
        var formerFile = null;
        // eslint-disable-next-line no-underscore-dangle
        if (file._file) formerFile = file._file;
        // eslint-disable-next-line array-callback-return
        if (type === "chat") {
            awsFields.map(function(field) {
                return fd.append(field.name, field.value);
            });
        } else if (type === "stream") {
            awsFields.map(function(field) {
                return fd.append(field.key, field.value);
            });
        }
        if (!formerFile) {
            fd.append("file", file);
        } else {
            fd.append("file", formerFile);
        }
        return fetch(url, {
            method: "POST",
            cache: "default",
            body: fd,
            mode: "no-cors"
        }).then(function(response) {
            resolve(response.ok);
        }).catch(function(error) {
            reject(new Error(error));
        });
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (uploadHandler);


/***/ })

}]);